<template>
  <v-main class="validar-cuenta fill-height d-flex flex-column align-center justify-center pa-8">
    <v-progress-circular indeterminate color="primary" size="48" width="4" />
    <p class="text-body-2 text-medium-emphasis text-center mt-4">
      Validando su cuenta…
    </p>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ValidarCuentaView',
  mounted() {
    this.run()
  },
  methods: {
    ...mapActions({
      validateAccount: 'auth/validateAccount',
      setAlert: 'alerts/setAlert',
    }),
    async run() {
      const q = this.$route.query || {}
      const userId = q.userId ?? q.userid
      const rawToken =
        q.token ?? q.emailConfirmationToken ?? q.emailconfirmationtoken ?? q.code
      const emailConfirmationToken =
        rawToken != null && rawToken !== ''
          ? String(rawToken)
          : ''

      if (!userId || !emailConfirmationToken) {
        this.setAlert({
          type: 'warning',
          message:
            'El enlace de validación no es válido o está incompleto. Solicite un nuevo correo o contacte al administrador.',
        })
        await this.$router.replace({ path: '/login' })
        return
      }

      const payload = {
        userId: String(userId),
        emailConfirmationToken,
      }
      const result = await this.validateAccount(payload)
      if (result?.ok) {
        this.setAlert({
          type: 'success',
          message: 'Su cuenta fue validada éxitosamente. Ya puede iniciar sesión.',
        })
      }

      await this.$router.replace({ path: '/login' })
    },
  },
}
</script>

<style scoped>
.validar-cuenta {
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}
</style>
